import { Program } from '../types';

export enum ProgramActionType {
    GET_ALL_PROGRAMS = 'GET_ALL_PROGRAMS',
    GET_ALL_ADMIN_PROGRAMS = 'GET_ALL_ADMIN_PROGRAMS',
    GET_PROGRAM = 'GET_PROGRAM',
    CREATE_PROGRAM = 'CREATE_PROGRAM',
    UPDATE_PROGRAM = 'UPDATE_PROGRAM',
    DELETE_PROGRAMS = 'DELETE_PROGRAMS',
    MERGE_PROGRAMS = 'MERGE_PROGRAMS',
}

interface GetAllProgramsAction {
    type: ProgramActionType.GET_ALL_PROGRAMS;
    payload: Array<Program>;
}

interface GetAllAdminProgramsAction {
    type: ProgramActionType.GET_ALL_ADMIN_PROGRAMS;
    payload: Array<Program>;
}

interface GetProgramAction {
    type: ProgramActionType.GET_PROGRAM;
    payload: Program;
}

interface CreateProgramAction {
    type: ProgramActionType.CREATE_PROGRAM;
    payload: Program;
}

interface UpdateProgramAction {
    type: ProgramActionType.UPDATE_PROGRAM;
    payload: Program;
}

interface DeleteProgramsAction {
    type: ProgramActionType.DELETE_PROGRAMS;
    payload: Array<Program>;
}

interface MergeProgramsAction {
    type: ProgramActionType.MERGE_PROGRAMS;
    payload: Array<Program>;
}

export type ProgramAction =
    | GetAllProgramsAction
    | GetAllAdminProgramsAction
    | GetProgramAction
    | CreateProgramAction
    | UpdateProgramAction
    | DeleteProgramsAction
    | MergeProgramsAction;
